import _ from "lodash";
import {expertPaymentActions} from "_actions";

export function formatName(firstName, lastName) {
    const first = firstName?.trim() || '';
    const last = lastName?.trim() || '';
    return `${first} ${last}`.trim();
}

export function submitAction(dispatch, selectedUserIds) {
    if(_.isEmpty(selectedUserIds)) return;
    return dispatch(expertPaymentActions.clearBalance(buildClearBalancePayload(selectedUserIds)));
}

export function buildClearBalancePayload(userIds = []) {
    return {
        users: userIds,
    };
}